import './carousel.css'

import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { Box, HStack, Stack, Text } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { carouselLeftBtnClick, carouselRightBtnClick, thumbnailRenderer } from 'src/util/helpers'

import ImageCard from './ImageCard'

export default function Carousel({
  title,
  data,
  auth,
  dataKeyName = 'name',
  navUrl = 'coursedetails',
  hasStartButton = true,
  contentEditable = false,
  isAdmin,
  page,
  courseKey,
  showProgress,
  seeAllBtnFn,
  showAllCourse,
  pageName = '',
  showCardMetaData,
  identifier,
  cardWidth,
  cardWHeight,
  cardRatio
}) {
  const scrollContainerRef = useRef(null)
  const [showLeftBtn, setShowLeftBtn] = useState(false)
  const [showRightBtn, setShowRightBtn] = useState(false)

  const checkScroll = () => {
    const el = scrollContainerRef.current
    if (!el) return

    const hasLeftScroll = el.scrollLeft > 0
    const hasRightScroll = el.scrollWidth > el.clientWidth + el.scrollLeft

    setShowLeftBtn(hasLeftScroll)
    setShowRightBtn(hasRightScroll)
  }

  useEffect(() => {
    checkScroll()
    const el = scrollContainerRef.current
    if (!el) return

    el.addEventListener('scroll', checkScroll)
    window.addEventListener('resize', checkScroll)

    return () => {
      el.removeEventListener('scroll', checkScroll)
      window.removeEventListener('resize', checkScroll)
    }
  }, []) // run when data changes


  return (
    <Stack gap="1" width="100%">
      <HStack width="100%" justifyContent="space-between">
        {title && (
          <Text color="#2469F5" fontSize={18} fontWeight={'bolder'} textTransform="capitalize" marginBottom="10px">
            {title}
          </Text>
        )}
        {seeAllBtnFn && (
          <button
            className="seeAllBtn"
            onClick={() => {
              seeAllBtnFn(courseKey, !showAllCourse)
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
            }
          >
            {showAllCourse ? (
              (showLeftBtn || showRightBtn) && (
                <>
                  See All <ChevronRightIcon w={4} h={4} />
                </>
              )
            ) : (
              <>
                <ChevronLeftIcon w={4} h={4} /> Back
              </>
            )}
          </button>
        )}
      </HStack>
      {/* <Divider /> */}
      <HStack
        ref={scrollContainerRef}
        className={showAllCourse ? 'carouselSlider' : 'carouselSliderForAll'}
        overflow="scroll"
        style={{ marginBottom: "20px", marginTop: "0px" }}
      >
        {/* <CarouselComponent> */}
        {showLeftBtn && (
          <button
            className="carousel-left-arrow arrow"
            onClick={carouselRightBtnClick}
          >
            &lt;
          </button>
        )}
        {data.length ? data.map((crs, index) => {
          let progress = 0
          if (crs.progress && crs.progress.progress) {
            progress = crs.progress.progress
          }
          let continueLearning = false
          if (crs.difficultyLevel === 'continueLearning') {
            showProgress = true
            continueLearning = true
            navUrl = `introduction/course/${crs.course}/chapter/${crs.chapter}/unit/${crs.unit}/lesson/${crs.lesson}`
          }
          return (
            <ImageCard
              navUrl={pageName || continueLearning ? navUrl : `language/${crs.course}/${navUrl}`}
              showCardMetaData={showCardMetaData}
              hasStartButton={hasStartButton}
              key={crs.id + `${index}`}
              contentEditable={contentEditable}
              isAdmin={isAdmin}
              page={page}
              auth={auth}
              showAllCourse={showAllCourse}
              id={crs[identifier] || crs.id || crs._id}
              lessonCount={crs.lessonCount}
              activitiesCount={crs.activitiesCount}
              chapterCount={crs.chapterCount}
              linkedExerciseCount={crs?.linkedExerciseIds?.length}
              linkedVocabularyCount={crs?.linkedVocabularyIds?.length}
              src={thumbnailRenderer(crs)}
              continueLearning={continueLearning}
              name={crs[dataKeyName]}
              hrs={crs['hrs']}
              minutes={crs['minutes']}
              seconds={crs['seconds']}
              progress={progress}
              showProgress={showProgress}
              cardWidth={cardWidth}
              cardWHeight={cardWHeight}
              aspectRatio={cardRatio}
            />
          )
        }) : <Box>No lessons here</Box>}
        {showRightBtn && (
          <button
            className="carousel-right-arrow arrow"
            onClick={carouselLeftBtnClick}
          >
            &gt;
          </button>
        )}
        {/* </CarouselComponent> */}
      </HStack>
    </Stack>
  )
}
